export const isColor = (color) => {
    const optionStyle = new Option().style;
    optionStyle.color = color;
    return optionStyle.color !== "";
}